import React from "react";
class MapGreatSmokyMountains extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section id="map-great-smoky-mountains" className="about-us gray-light-bg">
          <iframe
            src="https://maps.google.com/maps?saddr=Gatlinburg,+TN&daddr=Sugarlands+Visitor+Center,+TN+to:Laurel+Falls+Trail,+TN+to:Clingmans+Dome,+TN+to:Alum+Cave+Trail,+TN+to:Cades+Cove,+TN+to:Cataloochee+Valley,+NC&output=embed"
            width="100%"
            height="420"
            title="Great Smoky Mountains route map">
          </iframe>
        </section>
      </React.Fragment>
    );
  }
}
export default MapGreatSmokyMountains;
